module.exports = __webpack_public_path__ + "static/img/6834_phase_function_Paper_Points.1d19ed5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6834_phase_function_Paper_Points.png
// module id = Ij/U
// module chunks = 0